import { Slider, Typography, Box } from '@mui/material';
import { toTitleSpaceCase } from '../../utils/main';

const generateColors = (total) => {
    return Array.from({ length: total }, (_, i) => {
        const hue = (i * 137.508) % 360;
        return `hsl(${hue}, 70%, 50%)`;
    });
};

const ProblemWiseDataUi = ({ chartData }) => {
    const totalProblems =
        chartData?.Product?.products.reduce(
            (acc, item) => acc + item.problems.length,
            0
        ) || 0;

    const colors = generateColors(totalProblems);
    const problemMap = new Map();

    chartData?.Product?.products.forEach((item) => {
        item.problems.forEach((problem) => {
            const name = problem.problem || '';
            const count = problem.count || 0;

            if (!problemMap.has(name)) {
                problemMap.set(name, { problem: name, count: 0 });
            }
            problemMap.get(name).count += count;
        });
    });

    const maxCount =
        Math.max(...Array.from(problemMap.values()).map((v) => v.count)) || 0;

    const data = Array.from(problemMap.values()).map((p, i) => ({
        ...p,
        color: colors[i],
        maxCount,
    }));

    return (
        <>
            {data.length !== 0 ? (
                <Box
                    sx={{
                        overflow: 'auto',
                        height: '35vh',
                        border: '1px solid #E6E6E6',
                        borderRadius: 2,
                        p: 2,
                    }}
                >
                    <Box sx={{ mb: 4 }}>
                        {data.map((problem, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 1,
                                    backgroundColor:
                                        index % 2 !== 0 ? '#f2f2f2' : 'transparent',
                                    p: 2,
                                    gap: 3,
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        width: 400,
                                        color: '#4D4D4D',
                                        fontFamily: 'Public Sans',
                                        fontWeight: 500,
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {toTitleSpaceCase(problem.problem)}
                                </Typography>

                                <Box sx={{ width:" 100%", display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                                    <Box maxWidth={"70%"}>
                                        <Slider
                                            value={problem.count}
                                            max={problem.maxCount}
                                            sx={{
                                                width: `${(problem.maxCount + 10) * 8}px`,
                                                '& .MuiSlider-thumb': { display: 'none' },
                                                '& .MuiSlider-track': {
                                                    backgroundColor: problem.color,
                                                    height: 8,
                                                },
                                                '& .MuiSlider-rail': {
                                                    backgroundColor:
                                                        index % 2 !== 0 ? '#f2f2f2' : 'transparent',
                                                    height: 8,
                                                },
                                            }}
                                        />
                                    </Box>

                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{ minWidth: 30 }}
                                        >
                                            {problem.count}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '35vh',
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{ color: '#999999', fontFamily: 'Public Sans' }}
                    >
                        No Data Available
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default ProblemWiseDataUi;
